import React from 'react';
import PropTypes from 'prop-types';

const SVG = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" className={props.className}>
    <g fill="none" fillRule="evenodd" stroke="#B5B4B8" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
      <path d="M7.5 8.5v4M5.5 10.5h4M13.5 2.5h-12a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1zM.5 5.5h14M4.5.5v2M10.5.5v2" />
    </g>
  </svg>
);

SVG.propTypes = {
  className: PropTypes.string,
};

export default SVG;
